import { IAdapter } from '@shared/interfaces/IAdapter';


export abstract class AbstractAdapter implements IAdapter {
  abstract adapt(item: any, mapper?: unknown): any;

  processMapping(adaptMapper: unknown, item: unknown, mappingObject: unknown): void {
    Object.keys(adaptMapper).forEach((property) => {
      const mapping = adaptMapper[property];
      const propertyKey = (mapping.hasOwnProperty('alternativeKeyName')) ? mapping.alternativeKeyName : property;
      const itemProperty = this.getInitialProperty(propertyKey, item, mapping);

      if (mapping.hasOwnProperty('dataType') && mapping.dataType === 'array' && Array.isArray(itemProperty)) {
        const collection: any[] = [];
        itemProperty.forEach((subItem) => {
          collection.push(this.getProperty(subItem, mapping));
        });

        mappingObject[property] = collection;
      } else {
        // this.assignData(item, property, mapping, mappingObject);
        mappingObject[property] = this.getProperty(itemProperty, mapping);
      }
    });
  }

  // Get initial property
  private getInitialProperty(propertyKey, item: any, mapping: any): any {
    let initialProperty;
    if (item !== null && item.hasOwnProperty(propertyKey)) {
      if (item[propertyKey] === null && mapping.hasOwnProperty('nullValueSub')) {
        initialProperty = mapping['nullValueSub'];
      } else {
        initialProperty = item[propertyKey];
      }
    } else {
      initialProperty = ((mapping.hasOwnProperty('default')) ? mapping.default : null);
    }

    return initialProperty;
  }

  // Use mapping to define how to handle property
  private getProperty(property, mapping): any {
    if (mapping.hasOwnProperty('adapter')) {
      return mapping.adapter.adapt(property);
    }

    if (mapping.hasOwnProperty('cast')) {
      switch (mapping.cast) {
        case 'stringToBoolean':
          property = property === '1' ? true : false;
          break;
        // TODO: more to be added
        default:
          break;
      }
    }

    return property;
  }
}
